import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="klaviyo-cart"
export default class extends Controller {
  static values = { 
    addToCartData: Object,
    userEmail: String,
    hasAddToCart: Boolean 
  }

  connect() {
    if (this.hasAddToCartValue) {
      // Track to Klaviyo
      if (typeof klaviyo !== 'undefined') {
        this.trackAddToCart()
      }
      
      // Track to GTM dataLayer
      this.trackGTMAddToCart()
    }
  }

  trackAddToCart() {
    const addToCartData = this.addToCartDataValue
    
    if (this.userEmailValue) {
      // User is logged in - identify first, then track
      klaviyo.identify({
        '$email': this.userEmailValue
      }).then(() => {
        this.pushAddToCartEvent(addToCartData)
      }).catch((error) => {
        console.log("Klaviyo identify error", error)
        // Still track the event even if identify fails
        this.pushAddToCartEvent(addToCartData)
      })
    } else {
      // Guest user - track directly
      this.pushAddToCartEvent(addToCartData)
    }
  }

  pushAddToCartEvent(data) {
    klaviyo.push(["track", "Added to Cart", data])
  }

  trackGTMAddToCart() {
    const cartData = this.addToCartDataValue
    
    if (!cartData || !cartData.Items || cartData.Items.length === 0) {
      return
    }

    // Transform Klaviyo data format to GA4 ecommerce format
    const items = cartData.Items.map(item => ({
      item_id: item.SKU || item.ProductID,
      item_name: item.ProductName,
      item_category: item.ProductCategories,
      price: parseFloat(item.ItemPrice),
      quantity: parseInt(item.Quantity)
    }))

    // Push to GTM dataLayer
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "USD",
          value: parseFloat(cartData.$value || 0),
          items: items
        }
      })
    }
  }
}